import partnerContractMarkdown from "../../revContrato_Parceiro_Melhores_Retiros.md?raw";
import partnerFaqMarkdown from "../../revFAQ_Parceiros_Melhores_Retiros_revisado.md?raw";

export type PartnerFaqItem = {
  id: string;
  question: string;
  answer: string;
};

const normalizeSource = (value: string) =>
  value
    .replace(/^\uFEFF/, "")
    .replace(/\r\n/g, "\n")
    .replace(/\\([._[\]()#+\-])/g, "$1")
    .trim();

const stripInlineMarkdown = (value: string) =>
  value
    .replace(/\*\*(.*?)\*\*/g, "$1")
    .replace(/\*(.*?)\*/g, "$1")
    .replace(/`([^`]+)`/g, "$1")
    .trim();

const extractVersionLabel = (value: string) => {
  const match = normalizeSource(value).match(/vers[aã]o\s+([0-9.]+\s*\/\s*\d{4})/i);
  return match?.[1]?.replace(/\s+/g, "") || "1.0/2026";
};

const normalizeForDisplay = (value: string) =>
  normalizeSource(value)
    .split("\n")
    .map((line) => {
      const trimmed = line.trim();
      if (!trimmed) return "";
      if (trimmed.startsWith("#")) {
        return stripInlineMarkdown(trimmed.replace(/^#+\s*/, ""));
      }
      return stripInlineMarkdown(trimmed);
    })
    .join("\n");

const parsePartnerFaq = (markdown: string): PartnerFaqItem[] => {
  const lines = normalizeSource(markdown).split("\n");
  const items: PartnerFaqItem[] = [];
  let currentQuestion = "";
  let currentAnswer: string[] = [];

  const pushCurrent = () => {
    if (!currentQuestion) return;
    const answer = currentAnswer
      .map((line) => stripInlineMarkdown(line))
      .filter(Boolean)
      .join("\n\n");

    items.push({
      id: String(items.length + 1),
      question: stripInlineMarkdown(currentQuestion),
      answer,
    });
  };

  for (const rawLine of lines) {
    const line = rawLine.trim();
    if (!line) {
      if (currentAnswer.length && currentAnswer[currentAnswer.length - 1] !== "") {
        currentAnswer.push("");
      }
      continue;
    }

    if (line.startsWith("## ")) {
      pushCurrent();
      currentQuestion = line.replace(/^##\s+/, "");
      currentAnswer = [];
      continue;
    }

    if (line.startsWith("# ")) {
      continue;
    }

    if (/^\*\*AJUSTE:\*\*/i.test(line)) {
      continue;
    }

    currentAnswer.push(line);
  }

  pushCurrent();
  return items;
};

export const partnerContractVersionLabel = extractVersionLabel(partnerContractMarkdown);

export const partnerContractDocument = {
  title: "Contrato de Adesão e Prestação de Serviços de Intermediação",
  versionLabel: partnerContractVersionLabel,
  raw: normalizeSource(partnerContractMarkdown),
  displayContent: normalizeForDisplay(partnerContractMarkdown),
};

export const partnerAcceptanceCopy = {
  contractCheckbox: `Li e concordo com os Termos de Parceria (versão ${partnerContractVersionLabel}).`,
  lgpdCheckbox:
    "Autorizo o tratamento dos meus dados pessoais para as finalidades de cadastro, intermediação de reservas e pagamentos, conforme a Política de Privacidade, nos termos da Lei nº 13.709/2018 (LGPD).",
  marketingCheckbox:
    "Aceito receber comunicações, novidades e ofertas da Melhores Retiros por e-mail e WhatsApp.",
  promotionHighlight:
    "Ao se cadastrar até 31/12/2026, você garante 6 meses gratuitos, sem mensalidade e sem comissão.",
};

export const partnerFaqItems = parsePartnerFaq(partnerFaqMarkdown);
